@if (statusText()) {
  <app-pan-chip [color]="statusColor()" [width]="152">{{ statusText() }}</app-pan-chip>
}
